import { t } from '@lingui/macro'
import { AnimatePresence } from 'framer-motion'
import { forwardRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppHeader } from '@/@bothrs-ui/web/components/navigation/header/AppHeader'
import { AnimatedContainer, StContent, StHeader } from './ContentIframePageLayout.styled'

import type { ReactNode } from 'react'

type Props = {
  onGoBack?: () => void
  children: ReactNode
}

const ContentIFramePageLayout = forwardRef<HTMLDivElement, Props>(({ children, onGoBack }: Props, ref) => {
  const navigate = useNavigate()

  // Interaction Methods
  // ------------------------------------------------------------------------- /
  const handleGoBack = useCallback(() => {
    if (onGoBack) {
      onGoBack()
    } else {
      navigate(-1)
    }
  }, [navigate, onGoBack])

  return (
    <AnimatedContainer ref={ref}>
      <StHeader>
        <AppHeader
          secondaryAction={{
            label: t({ id: 'globals.close', message: 'Sluiten' }),
            icon: ['far', 'close'],
            onClick: handleGoBack,
          }}
        />
      </StHeader>
      <StContent>
        <AnimatePresence mode='popLayout' initial={false}>
          {children}
        </AnimatePresence>
      </StContent>
    </AnimatedContainer>
  )
})

ContentIFramePageLayout.displayName = 'ContentIFramePageLayout'

export { ContentIFramePageLayout }
